import { OPERTIONS_URL } from "../common/common"
import { ApiService } from "../service/api.service"

const apiServer = new ApiService()

export const getDraftData = async()=>{
 try {
    const response:any = await apiServer.getApi(`${OPERTIONS_URL}/draft-booking/get-all-route`)
    if (response.status === "200") {
        return response.body
    } else {
        throw new Error('Failed to fetch data')
    }

 } catch (error) {
    console.error('Error fetching data:', error)
    return null
 }
}

export const getOneDraftData = async(id:string)=>{
    try {
        const response:any = await apiServer.getApi(`${OPERTIONS_URL}/draft-booking/details-route?bookingId=${id}`)
        if (response.status === "200") {
            return response.body
        } else {
            throw new Error('Failed to fetch data')
        }
    
    } catch (error) {
        console.error('Error fetching data:', error)
        return null
    }
}

export const getTripData = async(id:string)=>{
    try {
        const response:any = await apiServer.getApi(`${OPERTIONS_URL}/trip/get-all-route?bookingId=${id}`)
        if (response.status === "200") {
            return response.body
        } else {
            throw new Error('Failed to fetch data')
        }
    
    } catch (error) {
        console.error('Error fetching data:', error)
        return null
    }
}